<script>
import {
  ArrowUpIcon,
} from "vue-feather-icons";
import appConfig from "@/app.config";
import axios from 'axios';
import { EventBus } from "@/event-bus";

// 초기세팅
function initialState() {
  return {
    token: "",
    login: {
      idx: 0,
      level: 0,
      nick: "",
      isLogin: false,
    },
    fields: [
      {key: 'name', label: '신청인', thClass: 'col-1 text-center font-size-11', tdClass: 'col-1 text-center'},
      {key: 'email', label: '이메일', thClass: 'text-center font-size-11', tdClass: 'col-1 text-center'},
      {key: 'insertTime', label: '신청일자', thClass: 'col-2 text-center font-size-11', tdClass: 'col-2 text-center'},
      {key: 'btn', label: '사용금지여부', thClass: 'col-2 text-center font-size-11', tdClass: 'text-center'},
    ],
    newsletterlist: [],
  };
}

export default {
  components: {
    ArrowUpIcon
  },
  data() {
    return initialState();
  },
  props: {
    selectedMenu: {
      type: String,
    },
  },
  computed: {
  },
  mounted() {
  },
  created() {
    this.first()
    EventBus.$on("altong-member", (val)=> {
      if (val=='listRefresh') {
        this.readAltongMemberList();
      }
    });
  },
  methods: {
    first() {
      let getLocalStorage = JSON.parse(localStorage.getItem('user'))
      if (getLocalStorage) {
        this.login.idx = getLocalStorage.idx
        this.login.nick = getLocalStorage.nick
        this.login.level = getLocalStorage.level
        this.token = getLocalStorage.token
        // 레벨 98 이하거나 로그인 안한상태면 첫화면으로
        if (this.login.level < 98) {
          this.$notify({ type: 'error', duration: 2000, title: '실패', text: '관리자 권한이 없습니다.' })
          this.$router.push('/');
        } else {
          this.readAltongMemberList()
        }
      } else {
        this.$notify({ type: 'error', duration: 2000, title: '실패', text: '관리자 권한이 없습니다.' })
        this.$router.push('/');
      }
    },
    readAltongMemberList() {
      try {
        axios({
          method: 'POST',
          url: appConfig.fastapi + '/auth/admin_read_newsletterlist',
          headers: {
            'access-token': this.token
          },
          data: {
            "mb_id": this.login.idx,
          },
        })
        .then((res) => {
          if (res.data.type == 'success') {
            this.newsletterlist = res.data.newsletterlist;
          }
        })
        .catch((error) => {
          console.log(error)
          if (error.response) {
            this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.detail })
          }
        })
      } catch (error) {
        this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
      }
    },
    changeIsBan(idx, isBan) {
      try {
        axios({
          method: 'POST',
          url: appConfig.fastapi + '/auth/admin_update_newsletter_ban',
          headers: {
            'access-token': this.token
          },
          data: {
            "mb_id": this.login.idx,
            "idx": idx,
            "isBan": isBan,
          },
        })
        .then((res) => {
          if (res.data.type == 'success') {
            this.$notify({ type: 'success', duration: 3000, 'title': '성공', text: '처리가 완료되었습니다.' })
            this.readAltongMemberList()
          }
        })
        .catch((error) => {
          console.log(error)
          if (error.response) {
            this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.detail })
          }
        })
      } catch (error) {
        this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
      }
    }
  },
}
</script>

<template>
  <div v-show="newsletterlist" class="rounded shadow">
    <div class="p-4 border-bottom">
      <h5 class="text-md-left text-center">알통 회원</h5>
      <div class="font-size-13 text-muted">* 확인필요 : 알통회원 엑셀로 따로 관리하는지 체크필요 신규 알통 신청자 있으면 알림 떠야될지 체크필요</div>
      <div class="font-size-13 text-muted">* 작업예정 : 전체 또는 선택하여 이메일 보내기</div>
      <div>
        <div class="row mt-4">

          <div class="col-12 pt-2">
            <div class="rounded shadow">

              <div class="">
                <div class="table table-sm table-responsive font-size-14">
                  <b-table 
                    id="cordingHistoryTable" 
                    ref="cordingHistoryTable" 
                    :fields="fields" 
                    :items="newsletterlist" 
                    :hover="true"
                    table-class="text-center">
                    <!-- 신청인 -->
                    <template #cell(mb_nick)="row">
                      <div class="badge text-secondary bg-white font-size-10">
                        {{ row.item.name }}
                      </div>
                    </template>
                    <!-- 이메일 -->
                    <template #cell(mb_email)="row">
                      <div class="badge text-secondary bg-white font-size-10">
                        {{ row.item.mb_email }}
                      </div>
                    </template>
                    <!-- 신청일자 -->
                    <template #cell(insert_time)="row">
                      <div class="badge text-secondary bg-white font-size-10">
                        {{ row.item.insertTime }}
                      </div>
                    </template>
                    <!-- 권한 -->
                    <template #cell(btn)="row">
                      <div class="">
                        <div class="">
                          <div class="p-2">
                            <div class="custom-control custom-switch">
                              <div class="form-group mb-0">
                                <input
                                  v-model="row.item.isBan"
                                  type="checkbox"
                                  class="custom-control-input"
                                  id="isBanControlInput"
                                  @change="changeIsBan(row.item.idx, row.item.isBan==0 ? 0 : 1)"
                                />
                                <label class="custom-control-label" for="isBanControlInput">
                                  <span v-if="row.item.isBan==0">
                                    <span class="font-size-11 text-secondary">사용중</span>
                                    <i class="mdi mdi-heart text-secondary"></i>
                                  </span>
                                  <span v-else>
                                    <span class="font-size-11 text-danger">사용금지됨</span>
                                    <i class="mdi mdi-close text-danger"></i>
                                  </span>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>